// Theme by default loads a jQuery as dependency of the main script.
// Let's include it using ES6 modules import.
import $ from 'jquery'

function prependSocials() {
  if ($(window).innerWidth() < 1199) {
    $(".socials_h").detach().insertAfter($(".__menu_main"));
  }
}
function prependSearchMobile() {
  if ($(window).innerWidth() < 1199) {
    $("#show-search-form").detach().insertBefore($(".switch_menu"));
  }
}
$(document).ready(function () {
  prependSocials();
  prependSearchMobile();
});


const btnSearch = document.querySelector('.search-toggle');
const searchContainer = document.querySelector('.search-form')
btnSearch.addEventListener('click', () => {
  btnSearch.classList.toggle('active');
  searchContainer.classList.toggle('active');
});

window.addEventListener('load', () => {
  let matches = document.querySelectorAll("ins.ADSENSE");

  Array.from(matches).forEach((element) => {
    let parentElement = element.parentElement;
    if (window.getComputedStyle(parentElement).getPropertyValue("display") === "none")  {
      element.remove();
    } else {
      element.classList.remove("ADSENSE");
      element.classList.add("adsbygoogle");
      (adsbygoogle = window.adsbygoogle || []).push({});
    }
  });

});


// WEBPACK FOOTER //
// ./resources/assets/js/app.js